import React from 'react';
import { observer } from 'mobx-react-lite';
import MapPin from 'ati-ui-react/components/icons/MapPin';
import { useStores } from 'hooks/useStores';
import useWindowSize from 'hooks/useWindowSize';
import FavoritesButton from 'generic/FavoritesButton';
import AvailabilityDescr from 'generic/AvailabilityDescr';
import PublicationDate from '../PublicationDate';
import { AddressStyles, AdressRow, DeletedMessage, DateAndViewsWrapper } from './AddressStyles';

const Address = observer(() => {
  const {
    advertsStore: { currentAdvert },
  } = useStores();
  const [width] = useWindowSize();

  const fullAddress = `${currentAdvert.city_verbose}${
    currentAdvert.address ? `, ${currentAdvert.address}` : ''
  }`;

  const renderAdress = () => {
    if (currentAdvert.status === 'active')
      return (
        <AdressRow>
          <MapPin height={14} width={14} />
          <div className="text">
            {fullAddress} <AvailabilityDescr availability={currentAdvert.availability} />
          </div>
        </AdressRow>
      );
    if (currentAdvert.status === 'archived')
      return <DeletedMessage>Объявление удалено</DeletedMessage>;
    return null;
  };

  return (
    <AddressStyles>
      {renderAdress()}
      {currentAdvert?.is_owner && (
        <DateAndViewsWrapper>
          <PublicationDate />
        </DateAndViewsWrapper>
      )}
      {!currentAdvert?.is_owner && width > 512 && (
        <FavoritesButton className="favorites on-truck-page" advert={currentAdvert} />
      )}
    </AddressStyles>
  );
});

export default Address;
